module.exports = __webpack_public_path__ + "img/moderate rain.63adf361.jpg";